module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "d-flex align-flex-start space-evenly pb-3 pt-4 px-5",
    style: (("border-bottom:0.1rem solid " + (_vm.globalColors.primary)))
  }, [_c('addressData'), _vm._v(" "), _c('billingData')], 1), _vm._v(" "), _c('section', {
    staticClass: "d-flex wrap"
  }, [_c('div', {
    staticClass: "flex-65"
  }, [_c('ordered-products'), _vm._v(" "), _c('payment-method')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-15"
  }, [_c('purchase-summary')], 1)]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-138b71e1","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Payment.vue
// module id = 1075
// module chunks = 23